import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import {
  ConfirmResetPasswordInput,
  confirmResetPassword,
  confirmSignIn,
  resetPassword,
  ResetPasswordInput,
  signIn,
  SignInInput,
} from "aws-amplify/auth";
import { Box, Button, Typography } from "@mui/material";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function SignInHeader() {
  return (
    <Box sx={{ mb: 3.5 }}>
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 700,
          fontSize: 28,
          color: '#0B1B2E',
          lineHeight: 1.2,
          mb: 0.75,
        }}
      >
        Welcome back
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontSize: 14,
          color: '#6B7A8D',
          fontWeight: 400,
        }}
      >
        Sign in to Control Tower
      </Typography>
    </Box>
  );
}

function SignInFooter() {
  const { toForgotPassword } = useAuthenticator();
  return (
    <Box sx={{ mt: 0.5 }}>
      <Box sx={{ textAlign: 'right', mt: 1 }}>
        <Button
          onClick={toForgotPassword}
          disableRipple
          sx={{
            color: '#4361EE',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 500,
            fontSize: 13,
            textTransform: 'none',
            p: 0,
            minWidth: 'auto',
            background: 'transparent !important',
            '&:hover': {
              background: 'transparent',
              textDecoration: 'underline',
              color: '#3A52D4',
            },
          }}
        >
          Forgot Password?
        </Button>
      </Box>
    </Box>
  );
}

function LoginForm() {
  const formFields = {
    signIn: {
      username: {
        placeholder: "Enter your email or phone number",
        isRequired: true,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        placeholder: "Enter your verification code",
        isRequired: true,
      },
    },
  };

  const components = {
    SignIn: {
      Header: SignInHeader,
      Footer: SignInFooter,
    },
  };

  const handleSignIn = async (input: SignInInput) => {
    if (emailRegex.test(input.username)) return signIn(input);
    input.username = `+91${input.username}`;
    return signIn(input);
  };

  const handleForgotPassword = async (input: ResetPasswordInput) => {
    if (emailRegex.test(input.username)) return resetPassword(input);
    input.username = `+91${input.username}`;
    return resetPassword(input);
  };

  const handleForgotPasswordSubmit = async (
    input: ConfirmResetPasswordInput
  ): Promise<void> => {
    if (emailRegex.test(input.username)) {
      await confirmResetPassword(input);
      return;
    }
    input.username = `+91${input.username}`;
    await confirmResetPassword(input);
  };

  const handleConfirmSignIn = async (input: any) => {
    return confirmSignIn(input);
  };

  return (
    <Authenticator
      services={{
        handleSignIn,
        handleConfirmSignIn,
        handleForgotPassword,
        handleForgotPasswordSubmit,
      }}
      formFields={formFields}
      components={components}
      hideSignUp
    />
  );
}

export default LoginForm;
